import { fromJS } from 'immutable'

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

const initialState = fromJS({
  location: null
})

export default function routerReducer(state = initialState, { type, payload } = {}) {
  if (type === LOCATION_CHANGE) {
    return state.set('location', fromJS(payload))
  }

  return state
}



// WEBPACK FOOTER //
// ./src/model/CustomRouteReducer.js